/**
 *  EDAP events
 */

const actionlocation = 'trending-module';

export const TRENDING_DESTINATION_LINK_CLICK = ({ lbsUuid }) => ({
  name: 'destination.link.click',
  data: {
    actionlocation,
    eventlbsuuid: lbsUuid
  }
});

export const TRENDING_CLICK_PREV = {
  name: 'nav.previous.click',
  data: {
    actionlocation
  }
};

export const TRENDING_CLICK_NEXT = {
  name: 'nav.next.click',
  data: {
    actionlocation
  }
};

export const MODULE_VIEW_EVENT_OPTIONS = {
  actionlocation
};
